module.exports = __webpack_public_path__ + "img/one-year-disney-v2.eb45b640.png";